import {request} from "@/utils/request";
import {BASE_URL} from "@/constants/config";
import {ENTITY_FORMS_ENDPOINTS} from "./entity_forms";

const main = `${BASE_URL}api/entity-id-form/`;

export const ENTITY_FORM_ENDPOINTS = {
  main,
  addAttribute: `${main}attribute/`,
  status: (attributeId) => `${main}project/status/${attributeId}`,
  count: (attributeId) => `${main}project/count/${attributeId}`,
  editAttribute: (attributeId) => `${main}attribute/${attributeId}`,
  attribute: (formId, type) => `${main}attribute/${formId}/${type}`,
  byId: (attributeId) => `${main}attribute/${attributeId}`,
};

class EntityForm {
  async addAttribute(payload) {
    return  await request({
      url: ENTITY_FORM_ENDPOINTS.addAttribute,
      method: "POST",
      body: payload,
    })
  }

  async editAttribute(payload, id) {
    return  await request({
      url: ENTITY_FORM_ENDPOINTS.editAttribute(id),
      method: "PUT",
      body: payload,
    })
  }

  async deleteAttribute(type, id) {
    await request({
      url: ENTITY_FORM_ENDPOINTS.byId(id),
      body: {
        type
      },
      method: "DELETE",
    });
  }

  async fetchStatus(id) {
    return await request({
      url: ENTITY_FORM_ENDPOINTS.status(id)
    })
  }

  async fetchCount(id) {
    return await request({
      url: ENTITY_FORM_ENDPOINTS.count(id)
    })
  }
}

export const EntityFormService = new EntityForm();
